import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
export const TextFieldSkeleton = (props) => {
    const height = props.readOnly ? '20px' : '36px';
    const width = props.readOnly ? '200px' : '100%';
    return (React.createElement("div", null,
        (props.readOnly || props.type === 'password') && (React.createElement(SkeletonShape, { variant: "rectangular", height: "20px", width: "150px", spaceStackEnd: "s" })),
        React.createElement(SkeletonShape, { variant: "rectangular", width: width, height: height }),
        props.hint && (React.createElement(SkeletonShape, { spaceStackStart: "s", variant: "rectangular", width: "200px", height: "20px" }))));
};
//# sourceMappingURL=TextField.skeleton.mjs.mjs.map